const actions = {
  DELETE_FILE: 'files/DELETE_FILE',
  FILE_DELETED: 'files/FILE_DELETED',
  SEARCH_FILE: 'files/SEARCH_FILE',
  UPDATE_FILE: 'files/UPDATE_FILE',
  UPDATE_FILE_REDUCER: 'files/UPDATE_FILE_REDUCER',
  UPDATE_RESULTS: 'files/UPDATE_RESULTS',
  UPLOAD_FILE: 'files/UPLOAD_FILE',
  UPLOADED_FILE: 'files/UPLOADED_FILE',
  LOAD_FILES: 'files/LOAD_FILES',
  LOAD_ALL_FILES: 'files/LOAD_ALL_FILES',
  LOAD_CATEGORIES: 'files/LOAD_CATEGORIES',
  CATEGORIES: 'files/CATEGORIES',
  DOWNLOAD_FILE: 'files/DOWNLOAD_FILE',
  ADD_CATEGORY: 'files/ADD_CATEGORY',
  UPDATE_CATEGORY: 'files/UPDATE_CATEGORY',
  ADD_TAG: 'files/ADD_TAG',
  UPDATE_TAG: 'files/UPDATE_TAG',
  RESET_STATE: 'RESET_STATE',
  LOADING_STATUS: 'files/LOADING_STATUS',
  LOAD_FILE: 'files/LOAD_FILE',
  LOAD_FILE_BY_ID: 'files/LOAD_FILE_BY_ID',
  SYNC_EMAIL: 'files/SYNC_EMAIL',
}

export default actions
